export default __webpack_public_path__ + "static/media/experience-icon.ed7796ec.svg";